<template>
  <section id="tbSection">
    <div class="modal-bg" v-show="bgActive" @click="closeSide"></div>
    <div class="tb-sidemenu-wrap" v-show="openSide">
      <div style="display: flex; align-items: center;" @click="goLogo()">
        <img
          src="../../../src/images/button/tbMeeting.png"
          style="width: 35px"
        />
        <span style="font-weight: bold; margin-left: 10px; font-size: 16px;"
          >스마트회의
        </span>
      </div>
      <ul class="tb-side-menu-wrap" style="margin-top: 24px;">
        <li :class="page.class" v-for="page in pageList" :key="page.link">
          <div class="side-list" style="margin-top: 5px;">
            <img :src="page.imagePath" />
            <div class="txt">{{ page.title }}</div>
          </div>
          <div
            v-for="obj in page.child"
            :key="obj.href"
            class="flex flex-row items-center child-row side-list"
            style="font-size: 12px;"
            @click="currentPage(obj)"
          >
            <img
              :class="obj.class"
              style="margin-left: 15px;"
              :src="obj.imagePath"
            />
            <span :class="obj.class">{{ obj.title }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="select-subTitle">
      <span>영상회의</span>
      <img src="../../../src/images/button/list.png" @click="openSideMenu" />
    </div>
    <div class="tb-header-container" style="display:flex; justify-content: space-between; margin: 10px 16px;">
      <div>
        <!-- <button
          class="reg-videoBtn"
          @click="goMeeting('video')"
          style="width: 50px; height: 30px; font-size: 13px;"
        >
          등록
        </button> -->
        <button
          class="join-meeting-btn"
          style="width: 80px; margin-left: 10px; height: 30px;"
          @click="openJoinMeetingDialog"
        >
          회의 접속
        </button>
      </div>
      <div class="search-wrap">
        <date-picker
          v-model="startDate"
          format="YYYY/MM/DD"
          value-type="format"
          :lang="lang"
          style="width: 120px; height: 30px; font-size: 12px;"
        ></date-picker>
        <span class="hyphen" style="margin: 0 5px; padding-top: 0; color: #333;"
          >~</span
        >
        <date-picker
          v-model="endDate"
          format="YYYY/MM/DD"
          value-type="format"
          :lang="lang"
          style="width: 120px; height: 30px; font-size: 12px;"
          :disabled-date="notBeforeStartDate"
        ></date-picker>
        <input
          style="width: 230px; margin-left: 6px; height: 30px; margin-right: 6px; padding-left: 10px; font-size: 12px;"
          type="text"
          v-model="searchText"
          placeholder="회의 제목 또는 개설자를 검색해주세요"
          @keyup.enter="search('sc')"
        />
        <select
          style="width: 100px; height: 30px; margin-left: 6px;"
          v-model="meetingStatus"
        >
          <option value="all">전체</option>
          <option value="r">예정</option>
          <option value="s">진행중</option>
          <option value="e">완료</option>
        </select>
        <button
          class="krx-search-btn"
          style="margin-left:6px"
          @click="search('sc')"
        ></button>
      </div>
    </div>
    <div class="contents-container" style="height: calc(100vh - 180px);">
      <div
        class="tb-header top"
        style="width: 100%; display: flex; align-items: center;"
      >
        <div style="width: 10%;">구분</div>
        <div style="width: 24%;">회의날짜</div>
        <div style="width: 8%;">진행 상태</div>
        <div style="width: 26%;">회의 제목</div>
        <div style="width: 15%;">개설자</div>
        <div style="width: 15%;">부서</div>
        <div style="width: 11%;">회의 참여</div>
      </div>
      <div
        class="tb-contents"
        style="width: 100%; height: 100%; overflow: auto;"
      >
        <div
          v-for="(listItem, index) in allPublicMeetingList"
          v-if="
            listItem.publicMeetingStatus === 'public' ||
              listItem.creator.email === $store.state.user.email
          "
          class="meetings-row"
          :key="index"
          :class="{ isToday: listItem.isToday }"
        >
          <div style="width: 100%; display: flex; align-items: center">
            <div v-if="listItem.type === 'video'" style="width: 10%;">
              <img
                style="position: relative; top:2px;"
                src="../../../src/images/button/krxVideo.png"
              />
              <span style="margin-left: 2px;">영상</span>
            </div>
            <div style="width: 24%;">
              {{ listItem.startDtime | formatDate3 }}
              {{ listItem.startDtime | formatTime }} ~
              {{ (listItem.displayEndDtime || listItem.endDtime) | formatTime }}
            </div>
            <div style="width: 8%;">{{ statusKr(listItem.status) }}</div>
            <div
              style="cursor: pointer; width: 26%;"
              v-if="
                listItem.creator.email === $store.state.user.email &&
                  listItem.status === 'r'
              "
            >
              <img
                v-if="listItem.allPublicMeeting"
                class="all-public-meeting"
                src="../../../src/images/button/allPublicMeeting.png"
              />{{ listItem.title }}
            </div>
            <div
              v-else-if="listItem.status === 'e' || listItem.status === 's'"
              @click="onInfo(listItem)"
              style="cursor: pointer; width: 26%;"
            >
              <img
                v-if="listItem.allPublicMeeting"
                class="all-public-meeting"
                src="../../../src/images/button/allPublicMeeting.png"
              />{{ listItem.title }}
            </div>
            <div
              style="cursor: pointer; width: 26%;"
              v-else-if="listItem.creator.email !== $store.state.user.email"
              @click="onInfo(listItem)"
            >
              <img
                v-if="listItem.allPublicMeeting"
                class="all-public-meeting"
                src="../../../src/images/button/allPublicMeeting.png"
              />{{ listItem.title }}
            </div>

            <div style="width: 15%;">
              {{ listItem.creator.username }}
            </div>
            <div style="width: 15%;">
              {{ listItem.creator.department }}
            </div>
            <div
              v-if="listItem.status === 's'"
              class="text-center"
              style="width: 10%;"
            >
              <button class="join-meeting-btn" @click="startMeeting(listItem)">
                참여하기
              </button>
            </div>
            <div v-else style="width: 10%;">
              -
            </div>
          </div>
        </div>

        <div
          v-for="(listItem, index) in listData"
          v-if="
            listItem.publicMeetingStatus === 'public' ||
              listItem.creator.email === $store.state.user.email
          "
          class="meetings-row"
          :key="index"
          :class="{ isToday: listItem.isToday }"
        >
          <div style="width: 100%; display: flex; align-items: center">
            <div v-if="listItem.type === 'video'" style="width: 10%;">
              <img
                style="position: relative; top:2px;"
                src="../../../src/images/button/krxVideo.png"
              />
              <span style="margin-left: 2px;">영상</span>
            </div>
            <div style="width: 24%;">
              {{ listItem.startDtime | formatDate3 }}
              {{ listItem.startDtime | formatTime }} ~
              {{ (listItem.displayEndDtime || listItem.endDtime) | formatTime }}
            </div>
            <div style="width: 8%;">{{ statusKr(listItem.status) }}</div>
            <div
              style="cursor: pointer; width: 26%;"
              v-if="
                listItem.creator.email === $store.state.user.email &&
                  listItem.status === 'r'
              "
              @click="onEdit(listItem)"
            >
              <img
                v-if="listItem.allPublicMeeting"
                class="all-public-meeting"
                src="../../../src/images/button/allPublicMeeting.png"
              />{{ listItem.title }}
            </div>
            <div
              v-else-if="listItem.status === 'e' || listItem.status === 's'"
              @click="onInfo(listItem)"
              style="cursor: pointer; width: 26%;"
            >
              <img
                v-if="listItem.allPublicMeeting"
                class="all-public-meeting"
                src="../../../src/images/button/allPublicMeeting.png"
              />{{ listItem.title }}
            </div>
            <div
              style="cursor: pointer; width: 26%;"
              v-else-if="listItem.creator.email !== $store.state.user.email"
              @click="onInfo(listItem)"
            >
              <img
                v-if="listItem.allPublicMeeting"
                class="all-public-meeting"
                src="../../../src/images/button/allPublicMeeting.png"
              />{{ listItem.title }}
            </div>
            <div style="width: 15%;">
              {{ listItem.creator.username }}
            </div>

            <div style="width: 15%;">
              {{ listItem.creator.department }}
            </div>
            <div
              v-if="listItem.status === 's'"
              class="text-center"
              style="width: 10%;"
            >
              <button class="join-meeting-btn" @click="startMeeting(listItem)">
                참여하기
              </button>
            </div>
            <div
              style="width: 10%;"
              v-else-if="listItem.status === 'e' && listItem.isRecord === true"
            >
              <button class="join-meeting-btn" @click="startVideo(listItem)">
                다시보기
              </button>
            </div>
            <div v-else style="width: 10%;">
              &nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
    <tb-video-meeting-create-dialog
      :dialog="videoMeetingCreateDialog.dialog"
      :meetingInfo="meetingInfo"
      :mode="meetingInfo.meetingMode"
      :isTimeFixed="false"
      :isRoomSelectable="false"
      :closeDialog="closeMeetingCreateDialog"
      @createdMeeting="createdMeeting"
    />
    <tb-edit-meeting-dialog
      :dialog="editMeetingDialog.dialog"
      :meetingInfo="editMeetingDialog.meeting"
      :isTimeFixed="false"
      @editedMeeting="editedMeeting"
    />

    <meeting-info-dialog
      :dialog="meetingInfoDialog.dialog"
      :defaultMeeting="meetingInfoDialog.meeting"
      :closeDialog="closeMeetingInfoDialog"
      @editedMeeting="editedMeeting"
    />

    <video-dialog
      :dialog="videoDialog.dialog"
      :meetingInfo="videoDialog.meetingInfo"
      :closeDialog="closeVideoDialog"
    />

    <citizen-participation-dialog
      :dialog="citizenParticipationDialog.dialog"
      :closeDialog="closeJoinMeetingDialog"
    />
  </section>
</template>

<script>
import BaseModal from '@/components/popup/BaseModal';
import TbVideoMeetingCreateDialog from '@/components/popup/TbVideoMeetingCreateDialog';
import TbEditMeetingDialog from '@/components/popup/TbEditMeetingDialog';
import MeetingInfoDialog from '@/components/popup/MeetingInfoDialog';
import MeetingListEditDialog from '@/components/popup/MeetingListEditDialog';
import OpenConferenceCreateDialog from '@/components/popup/OpenConferenceCreateDialog';
import CitizenParticipationDialog from '@/components/popup/CitizenParticipationDialog';
import VideoDialog from '@/components/popup/VideoDialog';
import Pagination from 'vue-pagination-2';
import debounce from 'lodash.debounce';
import Util from '@/util';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    BaseModal: BaseModal,
    TbEditMeetingDialog,
    MeetingInfoDialog,
    MeetingListEditDialog,
    OpenConferenceCreateDialog,
    TbVideoMeetingCreateDialog,
    CitizenParticipationDialog,
    Pagination,
    VideoDialog,
    DatePicker,
  },
  filters: {
    koDateFormat: function(time) {
      moment.locale('ko');
      return moment(time)
        .format('LL')
        .replace(/(\s*)/g, '');
    },
    displayLongString: function(str) {
      if (str.length > 13) {
        return str.substring(0, 13) + '...';
      } else {
        return str;
      }
    },
    conferenceDayFilter: function(day) {
      return moment(day).format('YYYY/MM/DD');
    },
  },
  data: () => ({
    lang: {
      days: ['일', '월', '화', '수', '목', '금', '토'],
      months: [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월',
      ],
      yearFormat: 'YYYY년',
      monthFormat: 'MM월',
      // the calendar title of month before year
      monthBeforeYear: false,
    },
    pickrFormat: 'YYYY.MM.DD',
    page: 1,
    perPage: 8,
    dataPerPage: 8,
    bgActive: false,
    openSide: false,
    allPublicMeetingList: [],
    startDate: moment()
      .add(-7, 'day')
      .format('YYYY/MM/DD'),
    endDate: moment()
      .add(7, 'day')
      .format('YYYY/MM/DD'),
    searchText: '',
    meetingStatus: 'all',
    isActive: 'none',
    isEndActive: 'none',
    meeting: [],
    meetingInfo: {
      meetingType: null,
      meetingMode: null,
    },
    videoMeetingCreateDialog: {
      dialog: false,
    },
    lectureMeetingCreateDialog: {
      dialog: false,
    },
    citizenParticipationDialog: {
      dialog: false,
    },
    myMeetingJoinDialog: {
      dialog: false,
    },
    myWindow: null,

    allSelected: false,
    checkedMembers: [] /* 체크박스 유저 정보 */,
    conStyle: {
      conferenceTitleW: 240,
      organizerW: 225,
      conferenceTimeW: 182,
      progressW: 199,
      conferencInfoeW: 122,
      modifyW: 132,
    },
    meetingControlDialog: {
      dialog: false,
      meeting: null,
    },
    addDialog: false,
    editDialog: false,
    removeDialog: false,
    listData: [],
    searchData: [],
    videoDialog: {
      dialog: false,
      meetingInfo: {},
    },
    curPageNum: 1,
    curSelectIndex: 0,
    meetingList: [],
    newData: {
      time: '',
      title: '',
      info: '',
    },
    selectedData: {
      time: '',
      title: '',
      info: '',
    },
    meetingInfoDialog: {
      dialog: false,
      meeting: null,
    },

    meetingEditDialog: {
      dialog: false,
      isRoomSelectable: false,
      meeting: null,
    },
    openConfEditDialog: {
      dialog: false,
      meeting: null,
    },
    searchType: 'meetingTitle',
    searchMeeting: null,
    userKey: null,
    userEmail: null,
    editMeetingDialog: {
      dialog: false,
      meeting: {},
    },
    isActive: false,
    pageList: [
      {
        class: 'm01',
        link: '/kMeetingTb',
        title: '전체회의',
        imagePath: '/static/images/button/all.svg',
        isActive: false,
        child: [
          {
            class: 'm02',
            link: '/kMeetingTb',
            title: '영상회의',
            imagePath: '/static/images/button/krxVideo.svg',
          },
          {
            class: 'active',
            link: 'conf',
            title: '회의록 작성',
            imagePath: '/static/images/button/conf.png',
          },
        ],
      },
    ],
  }),
  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      let numPages = Math.ceil(this.searchData.length / this.dataPerPage);
      return numPages === 0 ? 1 : numPages;
    },
    calListData() {
      if (this.meeting) {
        this.listData = this.meeting.filter(
          (el) => el.allPublicMeeting === false
        );
        this.allPublicMeetingList = this.meeting.filter(
          (el) => el.allPublicMeeting === true
        );
      } else {
        this.listData = [];
      }
      return this.listData;
    },
    calData() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      if (this.calListData) {
        return this.calListData.slice(startPage, limitPage);
      } else {
        return [];
      }
    },
    filterLimitMeeting() {
      let page = this.page;
      let startPage = (page - 1) * this.perPage;
      let limitPage = startPage + this.perPage;

      return this.meeting.slice(startPage, limitPage);
    },
  },
  watch: {
    meetingStatus(status) {
      this.search(status);
    },
  },
  async activated() {
    this.searchMeeting = null;

    await this.search('init');
  },
  created() {
    this.search('sc');

    this.searchMeeting = null;
    this.curPageNum = 1;
  },
  methods: {
    openJoinMeetingDialog() {
      this.citizenParticipationDialog.dialog = true;
    },
    currentPage(obj) {
      console.log(obj);
      if (obj.title === '회의실 신청') {
        window.open(obj.link, '_blank');
      } else if (obj.link === '/kMeetingTb') {
        location.reload();
      } else if (obj.link === '#') {
        alert('준비중인 서비스입니다.');
      } else if (obj.link === 'conf') {
        let userKey = decodeURI(
          decodeURIComponent(this.getURLParameter('userKey'))
        );

        let sk = decodeURI(
          decodeURIComponent(this.getURLParameter('sk'))
        );
        location.replace(`https://s-minutes.ksd.or.kr:8443?userId=${userKey}&sk=${sk}`);
        
      } else if (obj.link === 'dev') {
        let userKey = decodeURI(
          decodeURIComponent(this.getURLParameter('userKey'))
        );

        this.$http
          .post('/api/auth/ssoTbMbLogin', { userKey: userKey })
          .then((response) => {
            location.replace(
              'https://kmeeting.krx.co.kr:7777?userKey=' + response.data.userKey
            );
          })
          .catch((error) => {
            console.log(`##### error : `, error);
            this.loading = false;
            this.error = error.response.data.error;
          });
      } else {
        this.$router.push(obj.link);
      }
      this.pageList.forEach((element) => {
        element.isActive = false;
      });

      obj.isActive = true;
    },
    notBeforeStartDate(date) {
      return date < new Date(this.startDate);
    },
    statusKr(status) {
      let statusKr = '미완료';
      if (status === 'r') {
        statusKr = '예정';
      } else if (status === 's') {
        statusKr = '진행중';
      } else {
        statusKr = '완료';
      }
      return statusKr;
    },
    search: debounce(async function(state) {
      let userKey = decodeURI(
        decodeURIComponent(this.getURLParameter('userKey'))
      );
      this.userKey = userKey;
      this.userEmail = userKey + '@ksd.or.kr';
      this.page = 1;
      let startDate = null;
      let endDate = null;
      let neStatus = ['d'];
      if (state === 'init') {
        startDate = moment()
          .add(-7, 'day')
          .format('YYYY/MM/DD');

        endDate = moment()
          .add(7, 'day')
          .format('YYYY/MM/DD');
      } else if ('sc') {
        startDate = this.startDate;
        endDate = this.endDate;
      } else if (state === 'r') {
        this.meetingStatus = 'r';
      } else if (state === 's') {
        this.meetingStatus = 's';
      } else if (state === 'e') {
        this.meetingStatus = 'e';
      }

      if (this.meetingStatus === 'r') {
        neStatus.push('s');
        neStatus.push('e');
      } else if (this.meetingStatus === 's') {
        neStatus.push('e');
        neStatus.push('r');
      } else if (this.meetingStatus === 'e') {
        neStatus.push('r');
        neStatus.push('s');
      } else {
        neStatus = [];
      }

      let params = {
        searchMeeting: this.searchText,
        startDate: moment
          .tz(startDate + ' 00:00:00', moment.tz.guess())
          .utc()
          .format(),
        endDate: moment
          .tz(endDate + ' 23:59:59', moment.tz.guess())
          .utc()
          .format(),
        neStatus: neStatus,
        sort: 'desc',
        showPrivated: true, // 비공개 회의 표시 여부
        creator: this.$store.state.user.email,
        email: userKey + '@ksd.or.kr',
      };

      await this.$http
        .get('/api/v1/meetings', { params: params })
        .then((response) => {
          this.meeting = response.data;

          if (this.meeting) {
            this.listData = this.meeting.filter(
              (el) => el.allPublicMeeting === false
            );
            this.allPublicMeetingList = this.meeting.filter(
              (el) => el.allPublicMeeting === true
            );

            let sortPublicMeetingList = [];
            sortPublicMeetingList = this.allPublicMeetingList.filter(
              (el) => el.status === 's'
            );

            this.allPublicMeetingList.forEach((el) => {
              if (el.status === 'r') {
                sortPublicMeetingList.push(el);
              }
            });

            this.allPublicMeetingList.forEach((el) => {
              if (el.status === 'e') {
                sortPublicMeetingList.push(el);
              }
            });
            this.allPublicMeetingList = sortPublicMeetingList;
          } else {
            this.listData = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }, 50),
    submit() {
      const submitData = {
        id: this.newData.id,
        subject: this.newData.subject,
        desc: this.newData.desc,
      };
      /*
      Ajax 통신 후
        */
      this.addData(submitData);
      this.clearForm();
    },
    getURLParameter(sParam) {
      let sPageURL = window.location.search.substring(1);
      let sURLVariables = sPageURL.split('&');
      for (let i = 0; i < sURLVariables.length; i++) {
        let sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          return sParameterName[1];
        }
      }
    },
    editData() {
      const editData = {
        time: this.selectedData.time,
        title: this.selectedData.title,
        info: this.selectedData.info,
      };
      /*
      Ajax 통신 후
        */
      this.calListData.splice(this.curSelectIndex, 1, editData);
    },
    addData(submitData) {
      this.calListData.push(submitData);
      this.curPageNum = this.numOfPages;
    },
    removeData() {
      this.calListData.splice(this.curSelectIndex, 1);
      if (this.calData.length === 0) {
        this.prevPage();
      }
    },
    selectAll() {
      let calData = this.filterLimitMeeting;
      this.checkedMember = [];

      if (!this.allSelected) {
        for (let member = 0; member < calData.length; member++) {
          this.checkedMembers.push(calData[member].meetingKey);
        }
      } else {
        this.checkedMembers = [];
      }
    },
    onAdd() {
      this.addDialog = true;
    },
    onRemove(index) {
      this.curSelectIndex = this.calIndex(index);

      this.removeDialog = true;
    },
    onInfo(meeting) {
      this.bgActive = true;
      this.meetingInfoDialog.dialog = true;
      this.meetingInfoDialog.meeting = meeting;
    },
    async controlItem(item) {
      // Get Meeting
      let meetingInfo = (
        await this.$http.get(`/api/v1/meetings/info/${item._id}`)
      ).data;
      this.meetingControlDialog.meeting = meetingInfo;
      this.meetingControlDialog.dialog = true;
    },
    calIndex(index) {
      switch (this.curPageNum) {
        case 1:
          return index;
        default:
          return index + (this.curPageNum - 1) * this.dataPerPage;
      }
    },
    clearForm() {
      // for (let key in this.newData) {
      //   this.newData[key] = '';
      // }
    },
    prevPage() {
      this.curPageNum--;
    },
    closeMeetingInfoDialog(type) {
      this.bgActive = false;
      this.meetingInfoDialog.dialog = false;

      if (type === 'delete') {
        this.search('sc');
      }
    },
    closeMeetingControlDialog(type) {
      this.meetingControlDialog.dialog = false;
    },
    async startMeeting (item) {
      let userKey = decodeURI(decodeURIComponent(Util.getParam('userKey')));
      let email = this.$store.state.user.email;
      // SAEHA 방식
      this.loading = true;
      if (item.status === 'r') {
        this.bgActive = true;
        this.myMeetingJoinDialog.dialog = true;
        this.meetingInfo = item;

        // let meetingKey = encodeURI(encodeURIComponent(item.meetingKey));
        // let userKey = encodeURI(
        //   encodeURIComponent(this.$store.state.user.username)
        // );
        // this.myWindow = window.open(
        //   "/JoinMeetingDialog?meetingKey=" + meetingKey + "&userKey=" + userKey,
        //   "_blank",
        //   "width=360, height=225"
        // );
        return false;
      }
      item['me'] = {
        email: this.$store.state.user.email,
        displayName: this.$store.state.user.name
          ? this.$store.state.user.name
          : this.$store.state.user.email, // this.$store.state.user.displayFullName ? this.$store.state.user.displayFullName : this.$store.state.user.username
      };

      let params = {
        _id: item._id,
        me: item.me,
        email: this.$store.state.user.email,
        coSpaceUri: item.meetingKey,
        meetingKey: item.meetingKey,
        userKey: this.$store.state.user.name,
      };

      let layoutCode = null;
      let fixSeatList = null;

      if (item.exMeeting === true) {
        if (item.conferenceRoomActive === false) {
          console.log('외부망 일반회의');

          let joinUserType = 22;
          if (item.creator.email === email) {
            joinUserType = 1;
          }

          await this.$http
            .get(`/api/auth/joinUrlForDmzSaehaInfo`, { params: params })
            .then((response) => {
              let info = response.data;

              const ds = this.$BodaApp.defaultSettings(info.ds);

              this.$BodaApp.openJoin(
                {
                  roomCode: item.meetingKey,
                  template: Number(info.oj.template),
                  title: item.title,
                  joinUserType:
                    item.creator.email === this.$store.state.user.email
                      ? 1
                      : 13,
                  userId: info.userData.userId,
                  userName: info.userData.userName,
                  openOption: info.meetingInfo.roomOption,
                  appOption: { Q: { QSchm: 'ksdflow://' } },
                },
                () => {
                  console.log('success');
                },
                (errorCode, reason) => {
                }
              );
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        } else if (item.conferenceRoomActive === true) {
          console.log('외부망 CMS 미팅');
          // CMS 미팅인 경우
          await this.$http
            .get(`/api/auth/dmzSaehaInfo`, { params: params })
            .then((response) => {
              let info = response.data;
              const ds = this.$BodaApp.defaultSettings(info.ds);
              this.$BodaApp.openJoin(
                {
                  roomCode: info.oj.roomCode,
                  template: Number(info.oj.template),
                  title: item.title,
                  userType:
                    item.creator.email === this.$store.state.user.email
                      ? 1
                      : 13,
                  userId: info.userData.userId,
                  userName: info.userData.userName + `/${info.userData.userId}`, // this.$store.state.user.displaySaehaName ? this.$store.state.user.displaySaehaName : this.$store.state.user.username, // this.$store.state.user.displayFullName ? this.$store.state.user.displayFullName : this.$store.state.user.username,
                  openOption: info.oj.openOption,
                  joinOption: info.oj.joinOption,
                  appOption: { Q: { QSchm: 'ksdflow://' } },
                },
                () => {
                  console.log('success');
                },
                (errorCode, reason) => {
                  this.loading = false;
                }
              );

              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        }
      } else {
        if (item.conferenceRoomActive === false) {
          console.log('내부망 일반회의');
          this.$http
            .get(`/api/auth/joinUrlForSaehaInfo`, {
              params: params,
            })
            .then((response) => {
              let info = response.data;
              const ds = this.$BodaApp.defaultSettings(info.ds);
              this.$BodaApp.openJoin(
                {
                  roomCode: info.meetingInfo.meetingKey,
                  template: Number(info.oj.template),
                  title: info.meetingInfo.title,
                  userType: info.oj.joinUserType,
                  userId: info.userData.userId,
                  userName: info.userData.userName + `/${info.userData.userId}`,
                  openOption: info.meetingInfo.roomOption
                    ? info.meetingInfo.roomOption
                    : '',
                  appOption: { Q: { QSchm: 'ksdflow://' } },
                },
                () => {
                  console.log('success');
                },
                (errorCode, reason) => {
                  this.loading = false;
                }
              );
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        } else if (item.conferenceRoomActive === true) {
          console.log('내부망 CMS 미팅');
          // CMS 미팅인 경우
          await this.$http
            .get(`/api/auth/saehaInfo`, { params: params })
            .then((response) => {
              let info = response.data;
              const ds = this.$BodaApp.defaultSettings(info.ds);
              const joinInfo = {
                roomCode: info.oj.roomCode,
                template: Number(info.oj.template),
                title: info.oj.title,
                userType:
                  item.creator.email === this.$store.state.user.email ? 1 : 13,
                userId: info.oj.userId,
                userName: info.userData.userName + `/${info.userData.userId}`,
                openOption: info.oj.openOption,
                joinOption: info.oj.joinOption,
                appOption: { Q: { QSchm: 'ksdflow://' } },
              };
              console.log('join info: ', joinInfo);

              this.$BodaApp.openJoin(
                joinInfo,
                () => {
                  console.log('success');
                  // this.meeting = Object.assign({}, this.defaultMeeting);
                  // this.initMeeting();
                },
                (errorCode, reason) => {
                  
                }
              );

              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
            });
        }
      }
    },
    async onEdit(meeting) {
      console.log(meeting);
      this.editMeetingDialog.dialog = true;
      this.editMeetingDialog.meeting = meeting;
    },
    closeMeetingEditDialog() {
      this.meetingEditDialog.dialog = false;
      this.search();
    },
    closeOpenConfEditDialog() {
      this.openConfEditDialog.dialog = false;
      this.search();
    },
    async joinMeeting(meeting) {
      // Get Meeting Url
      let params = {
        email: this.$store.state.user.email,
        meetingId: meeting._id,
      };
      await this.$http
        .get('/api/v1/meetings/joinUrl', { params: params })
        .then((response) => {
          let joinUrl = response.data.joinUrl;
          window.open(joinUrl);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async deleteMeeting() {
      if (!this.checkedMembers || this.checkedMembers.length === 0) {
        return alert('미팅을 하나 이상 선택 하세요');
      }

      let params = {
        meetingKeys: this.checkedMembers,
      };
      await this.$http
        .delete('/api/v1/meetings', { params: params })
        .then((response) => {
          if (response.data === 'ok') {
            this.initMeeting();
          }
        })
        .catch((error) => {
          console.log(error);
        });

      // 선택 초기화
      this.checkedMembers = [];
    },
    startVideo(obj) {
      this.videoDialog.dialog = true;
      this.videoDialog.meetingInfo = obj;
    },
    closeVideoDialog() {
      this.videoDialog.dialog = false;
    },
    closeJoinMeetingDialog() {
      this.citizenParticipationDialog.dialog = false;
    },
    showEditBtn(listItem) {
      if (
        (['r'].includes(listItem.status) ||
          (listItem.conferenceRoomActive === true &&
            ['s'].includes(listItem.status))) &&
        listItem.creator.email === this.$store.state.user.email
      ) {
        return true;
      } else {
        return false;
      }
    },
    async searchMeetingList() {
      let searchMeeting = this.searchMeeting;
      let searchType = this.searchType;
      let params = {};
      if (searchType === 'meetingTitle') {
        params = {
          searchMeeting: searchMeeting,
          status: ['s'],
        };
      } else if (searchType === 'meetingCreator') {
        params = {
          analyticsCreator: searchMeeting,
          status: ['s'],
        };
      } else if (searchType === 'meetingDepartment') {
        params = {
          searchDepartment: searchMeeting,
          status: ['s'],
        };
      }

      await this.$http
        .get('/api/v1/meetings', {
          params,
        })
        .then((response) => {
          console.log(response);
          this.meeting = response.data.splice(0, 100);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    createdMeeting(ret) {
      console.log('createMeeting ');
      console.log(ret);
      this.search('sc');
    },
    myMeetingJoin(ret) {
      console.log(' ## myMeetingJoin ##');
      if (ret === 'close') {
        this.myMeetingJoinDialog.dialog = false;
        this.bgActive = false;
      } else {
        this.startMeeting(ret);
      }
    },
    closeMeetingCreateDialog() {
      this.videoMeetingCreateDialog.dialog = false;
      this.lectureMeetingCreateDialog.dialog = false;
      this.bgActive = false;
      this.search();
    },
    allowedStartDates(d) {
      return moment(d).format('YYYY/MM/DD') >= moment().format('YYYY/MM/DD');
    },
    allowedEndDates(d) {
      return (
        moment(d).format('YYYY/MM/DD') >=
        moment(this.startDate).format('YYYY/MM/DD')
      );
    },
    showDatePicker(state) {
      if (state === 'hero') {
        if ((this.isActive = '')) {
          this.isActive = 'none';
        }
      } else {
        console.log('????');
        if (this.isActive === 'none') {
          this.isActive = '';
          this.isEndActive = 'none';
        } else {
          this.isActive = 'none';
        }
      }
    },
    startDateChange() {
      this.isActive = 'none';
      // this.startDate(this.startDate);
    },
    showEndDatePicker() {
      if (this.isEndActive === 'none') {
        this.isEndActive = '';
        this.isActive = 'none';
      } else {
        this.isEndActive = 'none';
      }
    },
    endDateChange() {
      this.isEndActive = 'none';
      // this.startDate(this.startDate);
    },
    openVideoMeetingCreateDialog() {
      this.videoMeetingCreateDialog.dialog = true;
    },
    async goMeeting(data) {
      this.bgActive = true;
      // 등록된 회의실이 존재 하는지 체크
      switch (data) {
        case 'video':
          this.openVideoMeetingCreateDialog();
          break;
        case 'conference':
          this.$router.push({ name: 'Meeting' });
          break;
        case 'external':
          console.log('외부망으로 이동링크');
          break;
      }
    },
    openWindow() {
      let creator = encodeURI(encodeURIComponent('A100022112'));
      let messengerId = encodeURI(encodeURIComponent('123123132'));
      let member = encodeURI(encodeURIComponent('00000033|00000032|00000031'));
      let meetingType = encodeURI(encodeURIComponent('portalOrga'));
      this.myWindow = window.open(
        '/messengerDialog?userKey=' +
          creator +
          '&messengerId=' +
          messengerId +
          '&meetingType=' +
          meetingType +
          '&member=' +
          member,
        '_blank',
        'width=720, height=660'
      );
      return false;
    },
    goLogo() {
      this.$router.go(0);
    },
    editedMeeting() {
      this.editMeetingDialog.dialog = false;
      this.search('r');
    },

    openSideMenu() {
      this.openSide = true;
      this.bgActive = true;
      console.log('openSideMenu');
    },
    closeSide() {
      this.openSide = false;
      this.bgActive = false;
    },
  },
};
</script>
<style scoped>
.meetings-row div {
  font-size: 14px;
}

.meetings-row {
  height: 50px;
  font-size: 13px;
  text-align: center;
  font-weight: 300;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
}

.select-subTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 16px;
}

.all-public-meeting {
  position: relative;
  top: 3px;
  margin-right: 5px;
}

.side-list {
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;
  margin-left: 30px;
  height: 32px;
  width: 173px;
  cursor: pointer;
  font-size: 15px;
  color: #333;
}

.side-list:hover {
  border-radius: 4px;
  background: rgba(100, 73, 252, 0.06);
}
.txt {
  margin-left: 6px;
  font-size: 15px;
  color: #333;
}

.child-row span {
  font-size: 15px;
  margin-left: 6px;
}

.no-active {
  color: #cccccc;
}

.tb-side-menu-wrap {
  background-color: #f5f5f5;
  border-radius: 6px;
  padding: 20px 0;
}

#tbSection .top {
  height: 48px;
}
.top div {
  border-top: 1px solid #cccccc;
  border-bottom: 1px solid #cccccc;
  font-size: 13px;
  font-weight: 500;
}

img.active {
  width: 19px;
}
</style>



// WEBPACK FOOTER //
// src/components/krx/KmeetingTb.vue